/**
 * @flow
 * @relayHash c18867377bcad002ccae3064115da341
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type SetUserBkgColorInput = {
  userId: string,
  color: string,
  clientMutationId?: ?string,
};
export type SetBackgroundColorMutationVariables = {|
  input: SetUserBkgColorInput
|};
export type SetBackgroundColorMutationResponse = {|
  +setUserBkgColor: ?{|
    +user: ?{|
      +backgroundOption: ?string,
      +backgroundColor: ?string,
    |}
  |}
|};
export type SetBackgroundColorMutation = {|
  variables: SetBackgroundColorMutationVariables,
  response: SetBackgroundColorMutationResponse,
|};
*/


/*
mutation SetBackgroundColorMutation(
  $input: SetUserBkgColorInput!
) {
  setUserBkgColor(input: $input) {
    user {
      backgroundOption
      backgroundColor
      id
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "SetUserBkgColorInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input",
    "type": "SetUserBkgColorInput!"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "backgroundOption",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "backgroundColor",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "operationKind": "mutation",
  "name": "SetBackgroundColorMutation",
  "id": null,
  "text": "mutation SetBackgroundColorMutation(\n  $input: SetUserBkgColorInput!\n) {\n  setUserBkgColor(input: $input) {\n    user {\n      backgroundOption\n      backgroundColor\n      id\n    }\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "SetBackgroundColorMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "setUserBkgColor",
        "storageKey": null,
        "args": v1,
        "concreteType": "SetUserBkgColorPayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "user",
            "storageKey": null,
            "args": null,
            "concreteType": "User",
            "plural": false,
            "selections": [
              v2,
              v3
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "SetBackgroundColorMutation",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "setUserBkgColor",
        "storageKey": null,
        "args": v1,
        "concreteType": "SetUserBkgColorPayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "user",
            "storageKey": null,
            "args": null,
            "concreteType": "User",
            "plural": false,
            "selections": [
              v2,
              v3,
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "id",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      }
    ]
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '340f67596a49a6cb1635dc065fa7487b';
module.exports = node;



// WEBPACK FOOTER //
// ./src/js/mutations/__generated__/SetBackgroundColorMutation.graphql.js